import { createContext } from "react";
import { AppSettings, appSettingsDefault } from "./app-settings";

export const AppSettingsContext = createContext<AppSettings>(appSettingsDefault);
